import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';

import LazyLoad from 'react-lazyload';

import { translate } from 'react-i18next';

import TrackEditor from '../../../modules/artist/TrackEditor';
import TrackSearcher from '../../../modules/artist/misc/TrackSearcher';
import TrackStripLabels from '../../../modules/artist/misc/TrackStripLabels';
import TrackStrip from '../../../modules/artist/misc/TrackStrip';
import Fab from '../../../modules/misc/Fab';

import MasterLayout from '../../../../layouts/MasterLayout';

import './styles/tracks.css';


class Tracks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: null,
      trackEditor: null
    };
    this.dispatch = props.dispatch;
    this.handleSave=this.handleSave.bind(this);
    document.title = 'Administrate tracks';
  }

  componentWillMount() {
    this.props.getAllTracks();
    const { t } = this.props;
    this.texts = t('page.artist.management.tracks', {returnObjects: true});
  }


  handleFabAction(action) {
    switch (action) {
      case 'new':
        this.setState({ trackEditor: {} });
        break;
      default:
    }
  }

  handleTrackAction(action, track) {
    switch (action) {
      case 'editor':
        this.setState({ trackEditor: track })
        break;
      case 'downloadArtwork':
        this.props.downloadTrackArtwork(track);
        break;
      case 'unpublish':
        this.props.updateTrack(
          {...track, releaseDate: null}
        );
        break;
      case 'delete':
        this.props.deleteTrack(track);
        break;
      default:
    }
  }

  handleSave(track) {
    if (track._update)  this.props.updateTrack(track);
    else                this.props.createTrack(track);
    this.setState({trackEditor: null})
  }


  render() {
    const tracks =
      !this.state.filter ?
        this.props.tracks.tracks :
        this.props.tracks.tracks.filter(track => this.state.filter.indexOf(track._id) !== -1)

    return (
      <MasterLayout navbarTitle={this.texts.title} io={this.props.io}>
        <TrackSearcher
          tracks={this.props.tracks.tracks}
          onSearch={(filter) => this.setState({filter})}
        />

        {!this.props.io.loading && tracks.length === 0 ? (
          <div className="page-artist-management-tracks-empty">
              <h1> {this.texts.list.empty} </h1>
          </div>
        ) : (
          <div>
            <div className="page-artist-management-tracks-list">
              <TrackStripLabels />
                <Paper>
                  {
                    tracks.map((track, key) => {
                      return (
                        <LazyLoad key={key} offset={200} height={100} throttle={100} once>
                          <TrackStrip
                            onAction={(action) => this.handleTrackAction(action, track)}
                            track={track}
                          />
                        </LazyLoad>
                      )
                    })
                  }
                </Paper>
            </div>
          </div>
        ) }


        <TrackEditor
          track={this.state.trackEditor}
          onClose={() => this.setState({ trackEditor:null })}
          onSave={this.handleSave}
        />




        <Fab
          menu={[
            {
              title: this.texts.fab.new,
              icon: "note_add",
              onClick: () => this.handleFabAction('new')
            }
          ]}
          onSelect={this.handleSelect}
        />
      </MasterLayout>
    )
  }
}

Tracks.contextTypes = {
   router: PropTypes.object
}

export default translate('translations')(Tracks);



// WEBPACK FOOTER //
// ./src/components/pages/artist/management/Tracks.js